/* Vitrinas de la portada: baraja el fondo de búsquedas reales, pide a cada una su conteo y tres escaneos por
   Section Rendering (sections/vitrina-datos) y esconde las que no tengan cartas disponibles. Nada inventado:
   si una búsqueda no responde, la vitrina se queda como enlace, sin conteo ni escaneos. Los datos se guardan
   20 minutos en sessionStorage para que «Barajar» y volver a la portada no repitan peticiones.
   En el editor de temas (data-editor) no se baraja: se llenan los bloques en su orden. */
(function () {
  var sec = document.querySelector('[data-vitrinas]');
  if (!sec || !window.fetch || !window.DOMParser) return;
  var rejilla = sec.querySelector('[data-vitrinas-rejilla]');
  var barajar = sec.querySelector('[data-vitrinas-barajar]');
  var aviso = sec.querySelector('[data-vitrinas-aviso]');
  var pool, textos;
  try {
    pool = JSON.parse(sec.querySelector('[data-vitrinas-pool]').textContent);
    textos = JSON.parse(sec.querySelector('[data-vitrinas-textos]').textContent);
  } catch (e) {
    return;
  }
  if (!pool || !pool.length || !rejilla) return;
  var enEditor = sec.hasAttribute('data-editor');
  var cuantas = Math.min(parseInt(sec.dataset.cuantas, 10) || 6, pool.length);
  var molde = rejilla.querySelector('[data-vitrina]');
  if (!molde) return;
  molde = molde.cloneNode(true);
  molde.removeAttribute('data-shopify-editor-block');
  molde.querySelector('[data-vitrina-conteo]').textContent = '';

  /* Caché de sesión */
  var CLAVE = 'moons-vitrinas';
  var VIDA = 20 * 60 * 1000;
  var cache = {};
  try {
    var guardado = JSON.parse(sessionStorage.getItem(CLAVE) || 'null');
    if (guardado && guardado.t && Date.now() - guardado.t < VIDA && guardado.d) cache = guardado.d;
  } catch (e) {}
  function guarda() {
    try {
      sessionStorage.setItem(CLAVE, JSON.stringify({ t: Date.now(), d: cache }));
    } catch (e) {}
  }

  function datos(entrada) {
    if (cache[entrada.u]) return Promise.resolve(cache[entrada.u]);
    var separador = entrada.u.indexOf('?') === -1 ? '?' : '&';
    return fetch(entrada.u + separador + 'section_id=vitrina-datos', { headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var d = doc.querySelector('[data-vitrina-datos]');
        if (!d) throw new Error('sin datos');
        var res = { n: d.dataset.ignorados ? 0 : (parseInt(d.dataset.n, 10) || 0), fmt: d.dataset.nFmt || '', html: d.innerHTML.trim() };
        cache[entrada.u] = res;
        guarda();
        return res;
      });
  }

  function textoConteo(res) {
    if (res.n === 1) return textos.una;
    return textos.cartas.split('[n]').join(res.fmt || String(res.n));
  }

  function pinta(el, entrada, res) {
    el.href = entrada.u;
    el.setAttribute('data-url', entrada.u);
    el.querySelector('[data-vitrina-tipo]').textContent = entrada.t;
    el.querySelector('[data-vitrina-nombre]').textContent = entrada.n;
    var minis = el.querySelector('[data-vitrina-minis]');
    var conteo = el.querySelector('[data-vitrina-conteo]');
    if (res) {
      if (res.html) minis.innerHTML = res.html;
      conteo.textContent = textoConteo(res);
    } else {
      conteo.textContent = '';
    }
  }

  /* Editor de temas: los bloques se quedan en su orden; solo se llenan con sus datos */
  if (enEditor) {
    Array.prototype.forEach.call(rejilla.querySelectorAll('[data-vitrina]'), function (el) {
      var u = el.getAttribute('data-url');
      var entrada = pool.filter(function (p) { return p.u === u; })[0];
      if (!entrada) return;
      datos(entrada).then(function (res) { pinta(el, entrada, res); }, function () {});
    });
    return;
  }

  /* Barajar: orden aleatorio del fondo; cada tanda toma las siguientes sin repetir hasta agotarlo */
  var orden = [];
  var cursor = 0;
  function baraja() {
    orden = pool.map(function (_, i) { return i; });
    for (var i = orden.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = orden[i];
      orden[i] = orden[j];
      orden[j] = t;
    }
    cursor = 0;
  }
  function toma(k, usadas) {
    var lista = [];
    var vueltas = 0;
    while (lista.length < k && vueltas < pool.length * 2) {
      if (cursor >= orden.length) baraja();
      var entrada = pool[orden[cursor++]];
      vueltas++;
      if (usadas[entrada.u]) continue;
      usadas[entrada.u] = true;
      lista.push(entrada);
    }
    return lista;
  }
  function pide(lista) {
    return Promise.all(lista.map(function (entrada) {
      return datos(entrada).then(
        function (res) { return { entrada: entrada, res: res }; },
        function () { return { entrada: entrada, res: null }; }
      );
    }));
  }

  var vivo = 0;
  function tanda() {
    var id = ++vivo;
    var usadas = {};
    var elegidas = [];
    rejilla.setAttribute('aria-busy', 'true');
    function acumula(resultados) {
      resultados.forEach(function (x) {
        if (!x.res || x.res.n > 0) elegidas.push(x);
      });
    }
    function rellena() {
      var faltan = cuantas - elegidas.length;
      if (faltan <= 0 || Object.keys(usadas).length >= pool.length) return Promise.resolve();
      var lista = toma(faltan, usadas);
      if (!lista.length) return Promise.resolve();
      return pide(lista).then(function (r) {
        if (id !== vivo) return;
        acumula(r);
        return rellena();
      });
    }
    return rellena().then(function () {
      if (id !== vivo) return;
      var nuevos = elegidas.slice(0, cuantas).map(function (x) {
        var el = molde.cloneNode(true);
        pinta(el, x.entrada, x.res);
        return el;
      });
      if (nuevos.length) {
        while (rejilla.firstChild) rejilla.removeChild(rejilla.firstChild);
        nuevos.forEach(function (el) { rejilla.appendChild(el); });
      }
      rejilla.removeAttribute('aria-busy');
      if (aviso && textos.nuevas) aviso.textContent = textos.nuevas;
    });
  }

  baraja();
  if (barajar && pool.length > cuantas) {
    barajar.hidden = false;
    barajar.addEventListener('click', function () {
      if (rejilla.getAttribute('aria-busy') === 'true') return;
      tanda();
    });
  }

  /* Arranca cuando la sección se acerca a la pantalla (o de inmediato si no hay IntersectionObserver) */
  var arrancado = false;
  function arranca() {
    if (arrancado) return;
    arrancado = true;
    tanda();
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entradas) {
      if (entradas.some(function (e) { return e.isIntersecting; })) {
        io.disconnect();
        arranca();
      }
    }, { rootMargin: '600px 0px' });
    io.observe(sec);
    setTimeout(arranca, 4000);
  } else {
    arranca();
  }
})();
